import { Maybe } from "@jutro/types";
import { EdmMedicalPerson } from "lib/graphql/megaSchema";

export const isStaffManagerId = (id: Maybe<string>) => {
  return id === "660670d65a3c70eac6081608";
};

export const isTestUserPhone = (phone: Maybe<string>) => {
  return phone?.startsWith("111");
};

export const isNurse = (e: Pick<EdmMedicalPerson, "genre" | "npwz">) => {
  return e.genre === "NURSE" && e.npwz?.endsWith("P");
};

export const isMidwife = (e: Pick<EdmMedicalPerson, "genre" | "npwz">) => {
  return e.genre === "NURSE" && e.npwz?.endsWith("A");
};

export const isDoctor = (e: Pick<EdmMedicalPerson, "genre">) => {
  return e.genre === "DOCTOR";
};
